import { Button, Grid, Stack } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import { FC, useEffect, useState } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { UninstallApp } from '@/modules/utilities/uninstallApp/types/UninstallForm.ts'
import TextComponent from '@/core/components/form/TextComponent.tsx'

type Props = {
  form: UseFormReturn<UninstallApp>
  handlerSearchDevice: (registersNumber: string) => void
  onSubmit: () => void
  onCancel: () => void
  searchingDevice: boolean
}

const UninstallAppForm: FC<Props> = ({
  form,
  handlerSearchDevice,
  onSubmit,
  onCancel,
  searchingDevice
}) => {
  const [registersNumber, setRegistersNumber] = useState('')

  const {
    register,
    handleSubmit,
    formState: { errors, isValid }
  } = form

  useEffect(() => {
    return form.reset()
  }, [form])

  return (
    <Stack>
      <Stack
        direction="row"
        alignItems="center"
        my={4}
        sx={{ justifyContent: 'center', width: '100%' }}
      >
        <TextComponent
          variant="outlined"
          placeholder="Entre el Número de registro"
          value={registersNumber}
          sx={{
            outline: 'none',
            borderRadius: 0,
            borderTopLeftRadius: 4,
            borderBottomLeftRadius: 4,
            width: 300
          }}
          onChange={(event) => setRegistersNumber(event.target.value)}
        />
        <Button
          variant="contained"
          color="primary"
          sx={{
            borderRadius: 0,
            borderTopRightRadius: 4,
            borderBottomRightRadius: 4,
            height: 40
          }}
          loading={searchingDevice}
          loadingPosition="start"
          onClick={() => handlerSearchDevice(registersNumber)}
        >
          Buscar
        </Button>
      </Stack>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2} sx={{ p: 2 }}>
          <Grid size={{ xs: 6 }} sx={{ mb: 2 }}>
            <TextComponent
              label="IMEI"
              variant="outlined"
              slotProps={{ inputLabel: { shrink: true } }}
              error={!!errors.imei}
              helperText={errors.imei?.message}
              {...register('imei')}
              fullWidth
              disabled
            />
          </Grid>
          <Grid size={{ xs: 6 }}>
            <TextComponent
              label="Número de registro"
              fullWidth
              variant="outlined"
              slotProps={{ inputLabel: { shrink: true } }}
              error={!!errors.registersNumber}
              helperText={errors.registersNumber?.message}
              {...register('registersNumber')}
              disabled
            />
          </Grid>
          <Grid size={{ xs: 6 }} sx={{ mb: 2 }}>
            <TextComponent
              label="Marca"
              fullWidth
              variant="outlined"
              slotProps={{ inputLabel: { shrink: true } }}
              {...register('brand')}
              error={!!errors.brand}
              helperText={errors.brand?.message}
              disabled
            />
          </Grid>
          <Grid size={{ xs: 6 }}>
            <TextComponent
              label="Modelo"
              fullWidth
              variant="outlined"
              slotProps={{ inputLabel: { shrink: true } }}
              {...register('model')}
              error={!!errors.model}
              helperText={errors.model?.message}
              disabled
            />
          </Grid>
          <Stack
            direction="row"
            spacing={2}
            sx={{ justifyContent: 'end', width: '100%' }}
          >
            <Button
              variant="outlined"
              color="primary"
              sx={{
                minWidth: 110,
                borderColor: 'lightgray',
                color: 'black',
                '&:hover': {
                  borderColor: 'gray'
                }
              }}
              onClick={onCancel}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              type="submit"
              sx={{ minWidth: 110 }}
              startIcon={<DeleteIcon />}
              disabled={!isValid}
            >
              Desinstalar
            </Button>
          </Stack>
        </Grid>
      </form>
    </Stack>
  )
}

export default UninstallAppForm
